import * as React from 'react';
import { SVGProps } from 'react';

export const BedOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4454_84548)">
      <path
        d="M27.2243 19.6537H2.62423C2.51552 19.6537 2.42234 19.5864 2.38092 19.488C2.33951 19.3897 2.36539 19.2758 2.44304 19.2033L6.9779 14.9791C7.02449 14.9325 7.07108 14.9066 7.15909 14.9118L20.6342 15.036C20.7792 15.036 20.8931 15.1551 20.8931 15.2948C20.8931 15.4346 20.774 15.5537 20.6342 15.5537L7.26262 15.4294L3.28686 19.1308H27.2295C27.3744 19.1308 27.4883 19.2447 27.4883 19.3897C27.4831 19.5398 27.3692 19.6537 27.2243 19.6537Z"
        fill="#071114"
      />
      <path
        d="M29.4293 24.2868H2.62392C2.47897 24.2868 2.36508 24.1729 2.36508 24.0279V19.4361C2.36508 19.2912 2.47897 19.1773 2.62392 19.1773C2.76887 19.1773 2.88276 19.2912 2.88276 19.4361V23.7691H29.1704V20.6889C29.1704 20.544 29.2843 20.4301 29.4293 20.4301C29.5742 20.4301 29.6881 20.544 29.6881 20.6889V24.0279C29.6881 24.1729 29.5742 24.2868 29.4293 24.2868Z"
        fill="#071114"
      />
      <path
        d="M30.8942 17.0497C30.8476 17.0497 30.7958 17.0342 30.7544 17.0083L8.13191 2.62202C8.03355 2.55989 7.99214 2.44083 8.0232 2.33212C8.05426 2.2234 8.14226 2.15611 8.27168 2.14575L12.8117 2.15611C12.8635 2.15611 12.9101 2.17164 12.9515 2.19752L28.5905 12.3388C28.6268 12.3595 28.6527 12.3906 28.6734 12.4268L31.1116 16.6614C31.1738 16.765 31.153 16.8944 31.065 16.9772C31.0236 17.0238 30.9563 17.0497 30.8942 17.0497ZM9.16727 2.66343L30.1436 16.004L28.2644 12.7374L12.7341 2.67378L9.16727 2.66343Z"
        fill="#071114"
      />
      <path
        d="M29.393 19.2808C29.3464 19.2808 29.2998 19.2653 29.2532 19.2394L6.63586 4.8531C6.57891 4.81686 6.5375 4.75474 6.52197 4.68744C6.50644 4.62015 6.52197 4.54767 6.5582 4.49073L8.03359 2.29577C8.11124 2.17671 8.27172 2.14565 8.39078 2.2233C8.50985 2.30095 8.54091 2.46143 8.46326 2.5805L7.13283 4.55803L29.3153 18.6647L30.6509 16.6769C30.7286 16.5578 30.8891 16.5267 31.0081 16.6044C31.1272 16.682 31.1583 16.8425 31.0806 16.9616L29.6052 19.1565C29.5586 19.2394 29.4758 19.2808 29.393 19.2808Z"
        fill="#071114"
      />
      <path
        d="M27.9182 28.2987C27.794 28.2987 27.6853 28.2107 27.6646 28.0865L27.2245 25.6223C27.1986 25.4825 27.2918 25.348 27.4316 25.3221C27.5714 25.3014 27.706 25.3894 27.7319 25.5291L28.1719 27.9933C28.1978 28.1331 28.1046 28.2677 27.9648 28.2935C27.9493 28.2935 27.9337 28.2987 27.9182 28.2987Z"
        fill="#071114"
      />
      <path
        d="M3.88721 28.2989C3.87168 28.2989 3.85615 28.2989 3.84062 28.2937C3.70085 28.2678 3.60767 28.1332 3.63355 27.9934L4.07358 25.5293C4.09946 25.3895 4.23406 25.2963 4.37383 25.3222C4.5136 25.3481 4.60678 25.4827 4.5809 25.6225L4.14087 28.0866C4.12017 28.2108 4.01145 28.2989 3.88721 28.2989Z"
        fill="#071114"
      />
      <path
        d="M7.08633 19.5034C6.94138 19.5034 6.82749 19.3895 6.82749 19.2445V15.3982C6.82749 15.2532 6.94138 15.1394 7.08633 15.1394C7.23128 15.1394 7.34517 15.2532 7.34517 15.3982V19.2445C7.34517 19.3895 7.23128 19.5034 7.08633 19.5034Z"
        fill="#071114"
      />
      <path
        d="M4.72034 13.3069C4.71516 13.3069 4.70998 13.3069 4.70481 13.3069C4.55986 13.3018 4.45114 13.1775 4.4615 13.0326C4.60645 10.2785 6.69787 8.54429 6.78587 8.47182C6.89458 8.38381 7.06024 8.39934 7.14825 8.50806C7.23625 8.61677 7.22072 8.78243 7.11201 8.87043C7.0913 8.88596 5.11377 10.5374 4.97918 13.0584C4.96882 13.1982 4.85493 13.3069 4.72034 13.3069Z"
        fill="#071114"
      />
      <path
        d="M7.13333 11.0394C6.98838 11.0394 6.87449 10.9255 6.87449 10.7806L6.86931 8.66844L4.75719 8.67361C4.60706 8.68914 4.49835 8.55972 4.49835 8.41477C4.49835 8.26982 4.61224 8.15593 4.75719 8.15593L7.12815 8.15076C7.19545 8.15076 7.26275 8.17664 7.30934 8.22841C7.35593 8.275 7.38699 8.3423 7.38699 8.4096L7.39217 10.7806C7.39217 10.9203 7.2731 11.0394 7.13333 11.0394Z"
        fill="#071114"
      />
      <path
        d="M27.2243 19.6537H2.62423C2.51552 19.6537 2.42234 19.5864 2.38092 19.488C2.33951 19.3897 2.36539 19.2758 2.44304 19.2033L6.9779 14.9791C7.02449 14.9325 7.07108 14.9066 7.15909 14.9118L20.6342 15.036C20.7792 15.036 20.8931 15.1551 20.8931 15.2948C20.8931 15.4346 20.774 15.5537 20.6342 15.5537L7.26262 15.4294L3.28686 19.1308H27.2295C27.3744 19.1308 27.4883 19.2447 27.4883 19.3897C27.4831 19.5398 27.3692 19.6537 27.2243 19.6537Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M29.4293 24.2868H2.62392C2.47897 24.2868 2.36508 24.1729 2.36508 24.0279V19.4361C2.36508 19.2912 2.47897 19.1773 2.62392 19.1773C2.76887 19.1773 2.88276 19.2912 2.88276 19.4361V23.7691H29.1704V20.6889C29.1704 20.544 29.2843 20.4301 29.4293 20.4301C29.5742 20.4301 29.6881 20.544 29.6881 20.6889V24.0279C29.6881 24.1729 29.5742 24.2868 29.4293 24.2868Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M30.8942 17.0497C30.8476 17.0497 30.7958 17.0342 30.7544 17.0083L8.13191 2.62202C8.03355 2.55989 7.99214 2.44083 8.0232 2.33212C8.05426 2.2234 8.14226 2.15611 8.27168 2.14575L12.8117 2.15611C12.8635 2.15611 12.9101 2.17164 12.9515 2.19752L28.5905 12.3388C28.6268 12.3595 28.6527 12.3906 28.6734 12.4268L31.1116 16.6614C31.1738 16.765 31.153 16.8944 31.065 16.9772C31.0236 17.0238 30.9563 17.0497 30.8942 17.0497ZM9.16727 2.66343L30.1436 16.004L28.2644 12.7374L12.7341 2.67378L9.16727 2.66343Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M29.393 19.2808C29.3464 19.2808 29.2998 19.2653 29.2532 19.2394L6.63586 4.8531C6.57891 4.81686 6.5375 4.75474 6.52197 4.68744C6.50644 4.62015 6.52197 4.54767 6.5582 4.49073L8.03359 2.29577C8.11124 2.17671 8.27172 2.14565 8.39078 2.2233C8.50985 2.30095 8.54091 2.46143 8.46326 2.5805L7.13283 4.55803L29.3153 18.6647L30.6509 16.6769C30.7286 16.5578 30.8891 16.5267 31.0081 16.6044C31.1272 16.682 31.1583 16.8425 31.0806 16.9616L29.6052 19.1565C29.5586 19.2394 29.4758 19.2808 29.393 19.2808Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M27.9182 28.2987C27.794 28.2987 27.6853 28.2107 27.6646 28.0865L27.2245 25.6223C27.1986 25.4825 27.2918 25.348 27.4316 25.3221C27.5714 25.3014 27.706 25.3894 27.7319 25.5291L28.1719 27.9933C28.1978 28.1331 28.1046 28.2677 27.9648 28.2935C27.9493 28.2935 27.9337 28.2987 27.9182 28.2987Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M3.88721 28.2989C3.87168 28.2989 3.85615 28.2989 3.84062 28.2937C3.70085 28.2678 3.60767 28.1332 3.63355 27.9934L4.07358 25.5293C4.09946 25.3895 4.23406 25.2963 4.37383 25.3222C4.5136 25.3481 4.60678 25.4827 4.5809 25.6225L4.14087 28.0866C4.12017 28.2108 4.01145 28.2989 3.88721 28.2989Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M7.08633 19.5034C6.94138 19.5034 6.82749 19.3895 6.82749 19.2445V15.3982C6.82749 15.2532 6.94138 15.1394 7.08633 15.1394C7.23128 15.1394 7.34517 15.2532 7.34517 15.3982V19.2445C7.34517 19.3895 7.23128 19.5034 7.08633 19.5034Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M4.72034 13.3069C4.71516 13.3069 4.70998 13.3069 4.70481 13.3069C4.55986 13.3018 4.45114 13.1775 4.4615 13.0326C4.60645 10.2785 6.69787 8.54429 6.78587 8.47182C6.89458 8.38381 7.06024 8.39934 7.14825 8.50806C7.23625 8.61677 7.22072 8.78243 7.11201 8.87043C7.0913 8.88596 5.11377 10.5374 4.97918 13.0584C4.96882 13.1982 4.85493 13.3069 4.72034 13.3069Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M7.13333 11.0394C6.98838 11.0394 6.87449 10.9255 6.87449 10.7806L6.86931 8.66844L4.75719 8.67361C4.60706 8.68914 4.49835 8.55972 4.49835 8.41477C4.49835 8.26982 4.61224 8.15593 4.75719 8.15593L7.12815 8.15076C7.19545 8.15076 7.26275 8.17664 7.30934 8.22841C7.35593 8.275 7.38699 8.3423 7.38699 8.4096L7.39217 10.7806C7.39217 10.9203 7.2731 11.0394 7.13333 11.0394Z"
        stroke="#071114"
        strokeWidth="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_4454_84548">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BedOpen;
